import { graphql } from '@revelio/data-access';

export const GAME_GET_RESULTS_STATS_V2 = graphql(`
  query GetGameResultsStatsV2(
    $entities: [CompositionV3Ent!]!
    $filters: CompositionV3Filters!
    $corrections: CompositionV3Corrections!
    $role_taxonomy: Int!
    $skill_taxonomy: Int!
    $breakdown_options: CompositionV3BreakdownOptions!
    $filtersSentV2: SentimentV2Filters
    $msa: [ID!]
    $role_k150: [ID!]
    $seniority: [ID!]
    $payReq: PayV2Req
  ) {
    rawComposition: composition_v3(
      req: {
        entities: $entities
        filters: $filters
        corrections: $corrections
        role_taxonomy: $role_taxonomy
        skill_taxonomy: $skill_taxonomy
        breakdown_options: $breakdown_options
      }
    ) {
      entities {
        id
        short_name
        long_name
        metrics {
          headcount {
            id
            val
          }
          tenure {
            id
            val
          }
          salary {
            id
            val
          }
          growth_rate {
            id
            val
          }
          hiring_rate {
            id
            val
          }
          attrition_rate {
            id
            val
          }
        }
      }
    }

    posting(
      filters: {
        msa: $msa
        role_k150: $role_k150
        seniority: $seniority
        provider: [0]
        start_date: "2020-01-01"
        end_date: "2025-05-19"
      }
      dim1: geography
      dim2: date
    ) {
      metadata {
        id
        shortName
        longName
        __typename
      }
      category {
        metadata {
          id
          shortName
          longName
          __typename
        }
        metrics {
          time_to_fill
          active
          __typename
        }
        __typename
      }
      __typename
    }

    sentiment(filters: $filtersSentV2, dim1: geography) {
      result {
        scores {
          overall {
            count
            value
            month_id
            weight
            __typename
          }
        }
      }
    }

    pay_v2(req: $payReq) {
      entities {
        metadata {
          id
          short_name
          long_name
        }
        metrics {
          histogram {
            index
            total
          }
        }
      }
    }
  }
`);
